import * as React from 'react';
import { createFileRoute, useParams } from '@tanstack/react-router'
import { LoadingScreen } from '@/web/components/molecules/LoadingScreen'
import {categoriesQueryOptions, categoryMappingsQueryOptions} from '@/web/lib/queryOptions';
import {useMutation, useQueryClient, useSuspenseQuery} from "@tanstack/react-query";
import {CategoryMappingsList} from "@/web/components/molecules/CategoryMappingsList.tsx";
import {CategoryMappingFormModal} from "@/web/components/molecules/CategoryMappingFormModal.tsx";
import {addCategoryMapping} from "@/web/lib/services.ts";
import {Button} from "@/web/components/ui/button.tsx";

export const Route = createFileRoute('/categories/mappings/$subcategoryId')({
  loader: async ({ params, context }) => {
    return context.queryClient?.ensureQueryData(categoryMappingsQueryOptions(params.subcategoryId));
  },
  preload: true,
  component: CategoryMappingsComponent,
  pendingComponent: LoadingScreen,
});

function CategoryMappingsComponent() {
  const params = useParams({ from: '/categories/mappings/$subcategoryId' });
  const [isOpen, setIsOpen] = React.useState(false);
  const [mode, setMode] = React.useState<'create' | 'edit'>('create');
  const queryClient = useQueryClient();

  const addCategoryMappingMutation = useMutation({
    mutationFn: addCategoryMapping,
    onSuccess: () => {
      queryClient.invalidateQueries(categoryMappingsQueryOptions(params.subcategoryId));
      setIsOpen(false);
    },
  });

  const handleAddCategoryMapping = (storeId: string, storeCategoryId: string) => () =>  {

  }

  const { error, data } = useSuspenseQuery(categoryMappingsQueryOptions(params.subcategoryId));
  if(data) {
    console.log(data);
    return (<div>
      <div className="flex flex-row">
        <div className="flex-1">
          <h1 className="text-4xl font-bold">Mappings</h1>
        </div>
        <div className="flex flex-row w-[150px] justify-end gap-2">
          <Button onClick={() => setIsOpen(true)}>Add Mapping</Button>
        </div>
      </div>
      <CategoryMappingFormModal isOpen={isOpen} onOpenChange={setIsOpen} shoppyCategoryId={params.subcategoryId} onSubmit={handleAddCategoryMapping} />
      <CategoryMappingsList categoryMappings={data} />
    </div>)

  }
}
